import { Footer } from 'components/Footer'
import { Stack } from '@chakra-ui/react'
import { motion } from 'framer-motion'
// eslint-disable-next-line import/no-cycle
import { Header } from 'components/Header'
import { NotificationMessage } from 'components/NotificationMessage'
import { useVisualViewport } from 'hooks/useVisualViewportHeight'

const MotionStack = motion(Stack)

export const Layout = ({ children }) => {
  const {
    height: vvHeight,
    offsetTop: vvOffSetTop
  } = useVisualViewport()

  return (
    <MotionStack
      animate={{
        height: `${vvHeight}px`,
        y: vvOffSetTop
      }}
      transition={{
        type: 'spring',
        duration: 0.8
      }}
      position="fixed"
      top={0}
      left={0}
      width="100%"
      overflow="hidden"
      gap={0}
    >
      <Header />

      <Stack flex="1" minHeight="0" overflowY="auto">
        {children}
      </Stack>

      <NotificationMessage />

      <Footer />
    </MotionStack>
  )
}
